import { useContext } from 'react';

import type { ViewMoreModalParams } from './ViewMoreModalParams';
import { ViewMoreModalParamsContext } from './ViewMoreModalParamsContext';

export const useSetViewMoreModalParams = (): ((params: ViewMoreModalParams | null) => void) => {
	const context = useContext(ViewMoreModalParamsContext);
	if (!context) {
		return () => {};
	}
	return context.setParams;
};
